import React from "react";
import "./OpalEvaluationCard.css";

const OpalEvaluationCard = ({ code, date, evaluator, score, denominator }) => {

    const formattedDate = new Date(date).toLocaleDateString("en-US", {
        month: "short",
        day: "2-digit",
        year: "numeric",
    });

    return (
        <div className="opal-evaluation-card">
            {/* Left score box */}
            <div className="score-badge">
                <di>
                    <span className="score-number">{score}</span>
                    <span className="score-scale">/{denominator}</span>
                </di>
            </div>

            {/* Right content */}
            <div className="eval-content">
                <span className="eval-code">{code}</span>
                <span className="eval-date">{formattedDate}</span>
                <span className="eval-evaluator">By: {evaluator}</span>
            </div>
        </div>
    );
};

export default OpalEvaluationCard;
